/**
 * Created by Jonas Wålekvist on 2018-04-26.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {Timeline, TimelineLite} from "gsap"
import {DungeonQuestSymbolUtil} from "../../../utils/DungeonQuestSymbolUtil";
import {DungeonQuest} from "../../DungeonQuest";
import {DungeonQuestGameMode} from "../../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../../DungeonQuestSound";
import {ColossalSymbolInfo, DungeonQuestParsedGameData} from "../../server/data/DungeonQuestParsedGameData";
import {DungeonQuestModeData} from "../../server/DungeonQuestModeData";
import {DungeonQuestRandomFeatureBaseController} from "../DungeonQuestRandomFeatureBaseController";
import {DungeonQuestRandomTransformIntroView} from "./DungeonQuestRandomTransformIntroView";


export class DungeonQuestRandomTransformController extends DungeonQuestRandomFeatureBaseController {
    private _view:DungeonQuestRandomTransformIntroView;
    private _symbolToBeTransformed:string;
    private _symbolData:ColossalSymbolInfo;
    private _overlayReels:string[][];
    private _allOverlayPositions:[number, number][];

    constructor(index:number, name:string) {
        super(index, name);
        this._view = new DungeonQuestRandomTransformIntroView();
        DungeonQuest.randomTransform = this;
    }

    protected hasWin() {
        return this._mode == DungeonQuestGameMode.RANDOM_TRANSFORM;
    }

    protected parseFeatureSpecificGameData(data:ParsedGameData) {
        this._overlayReels = (<DungeonQuestParsedGameData>data).overlayReels;
        this._symbolToBeTransformed = (<DungeonQuestParsedGameData>data).symbolToBeTransformed;
        this._allOverlayPositions = DungeonQuestSymbolUtil.findOverlayPositions(this._overlayReels);
        this._symbolData = {
            entireSymbolVisible : true,
            position : DungeonQuestRandomTransformController.getTransformOrigin(this._symbolToBeTransformed),
            size : 1,
            symbol : DungeonQuestRandomTransformController.getTargetTransformSymbol(this._symbolToBeTransformed),
            transformTriggered : true
        };

    }

    private getReelSetName(symbol:string):string {
        if(symbol == "L1") {
            return "TRANSFORM_L1_REELSET";
        }
        if(symbol == "L2") {
            return "TRANSFORM_L2_REELSET";
        }
        if(symbol == "L3") {
            return "TRANSFORM_L3_REELSET";
        }
        if(symbol == "L4") {
            return "TRANSFORM_L4_REELSET";
        }

        return "";
    }

    protected getIntroFeatureAnimation():TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            () => SlotGame.sound.playEffect(DungeonQuestSound.getUpgradeIntroSymbolSound(this._symbolToBeTransformed)),
            this._view.getIntroAnimation(this._symbolToBeTransformed)
        ]);
        tl.add(() => {
            DungeonQuest.reelAreaEffectController.startReelAreaAttention();
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {
                reelSetName : this.getReelSetName(this._symbolToBeTransformed),
                reelSetPosition : 10
            }));
        }, "-=0.15");
        tl.add(() => DungeonQuest.reelAreaEffectController.getShowBackgroundTint(this._symbolToBeTransformed));
        tl.add(() => DungeonQuestModeData.instance.activateHighlightedReels());
        tl.add(() => EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_TRY_NEAR_WIN, 0)));

        //    tl.timeScale(0.5);
        return tl;
    }


    public onReelBounce(data:IReelStoppedData):void {
        if(!this.hasWin()) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        const tl:TimelineLite = new TimelineLite();
        tl.add(() => DungeonQuest.soundPlayer.playTransformExtraLandingSound(data.reelId));

        const attentionAnimations:Timeline[] = this.getSymbolOverlayAttentionAnimations(data.reelId, this._allOverlayPositions);
        if(attentionAnimations.length > 0) {
            tl.add(() => DungeonQuest.soundPlayer.playTransformSymbolAttention(data.reelId));
            tl.add(attentionAnimations, 0, "start", 0);
        }

        //ending
        if(data.reelId == 4) {
            tl.add(() => DungeonQuest.reelAreaEffectController.getHideBackgroundTint());
            tl.add(() => DungeonQuest.reelAreaEffectController.stopReelAreaAttention());
            tl.add(DungeonQuest.symbolTransformView.getNewShockWaveTransform(this._symbolData, this._allOverlayPositions));
        }

        tl.add(() => this.dispatchCompleteEvent(data.reelId));
    }


    private static getTargetTransformSymbol(symbolToBeTransformed:string) {
        if(symbolToBeTransformed == "L1") {
            return "M1";
        }
        if(symbolToBeTransformed == "L2") {
            return "M2";
        }
        if(symbolToBeTransformed == "L3") {
            return "M3";
        }
        if(symbolToBeTransformed == "L4") {
            return "M4";
        }
        return "";
    }

    private static getTransformOrigin(symbolToBeTransformed:string):[number, number] {
        /*       if(symbolToBeTransformed == "L1") { //Green, square
                   return [0, 3];
               }
               if(symbolToBeTransformed == "L2") { //Yellow, arrow up
                   return [2, 6];
               }
               if(symbolToBeTransformed == "L3") { //Blue, arrow down
                   return [2, 0];
               }
               if(symbolToBeTransformed == "L4") { // Red, circle
                   return [4, 3];
               }*/
        return [2, 3];
    }
}